import { Action, createReducer, on } from '@ngrx/store';
import { LoanCalculatorModel } from '../../model/loan-calculator.model';
import { BizflexActions } from './bizflex.actions';
import { CompanyModel } from '../../model/company.model';
import { DirectorModel } from '../../model/director.model';
import { AccessTokenPayload } from '../../type/access-token.type';
import { LeadModel } from '../../model/lead.model';
import { Helper } from '@core/util';
import { CURRENCY_SGD } from '@core/data-access';

export const BIZFLEX_FEATURE_KEY = 'bizflex';

export interface BizflexState {
  accessToken: string | null;
  signToken: string | null;
  jwt: AccessTokenPayload | null;
  applicationId: string | null;
  company: CompanyModel | null;
  currencyCode: string;
  director: DirectorModel | null;
  directors: DirectorModel[] | null;
  loanCalculator: LoanCalculatorModel | null;
  leadSubmissionToken: string | null;
  leadSubmission: LeadModel | null;
}

export interface BizflexPartialState {
  readonly [BIZFLEX_FEATURE_KEY]: BizflexState;
}

const initialBizflexState: BizflexState = {
  accessToken: null,
  signToken: null,
  applicationId: null,
  company: null,
  currencyCode: CURRENCY_SGD,
  director: null,
  directors: null,
  jwt: null,
  loanCalculator: null,
  leadSubmissionToken: null,
  leadSubmission: null,
};

const reducer = createReducer(
  initialBizflexState,
  on(BizflexActions.init, state => ({ ...state })),
  on(BizflexActions.reset, (_, { initialState }) => ({ ...initialBizflexState, ...initialState })),
  on(BizflexActions.setAccessToken, (state, { accessToken }) => {
    if (!accessToken) return { ...state, accessToken: null, jwt: null };
    const jwt = Helper.decodeJWT(accessToken);
    return { ...state, accessToken, jwt };
  }),
  on(BizflexActions.setSignToken, (state, { signToken }) => ({ ...state, signToken })),
  on(BizflexActions.setApplicationId, (state, { applicationId }) => ({ ...state, applicationId })),
  on(BizflexActions.setCompany, (state, { company }) => ({ ...state, company })),
  on(BizflexActions.setCurrencyCode, (state, { currencyCode }) => ({ ...state, currencyCode })),
  on(BizflexActions.setDirector, (state, { director }) => ({ ...state, director })),
  on(BizflexActions.setDirectors, (state, { directors }) => ({ ...state, directors })),
  on(BizflexActions.setLoanCalculator, (state, { loanCalculator }) => ({ ...state, loanCalculator })),
  on(BizflexActions.setLeadSubmissionToken, (state, { leadSubmissionToken }) => ({ ...state, leadSubmissionToken })),
  on(BizflexActions.setLeadSubmission, (state, { leadSubmission }) => ({ ...state, leadSubmission })),
);

export function bizflexReducer(state: BizflexState | undefined, action: Action) {
  return reducer(state, action);
}
